module.exports = __webpack_public_path__ + "img/a1db38b7917b1d5dcda474413da4c084.png";